import React, { Component } from "react";
import { MDBRow, MDBCol, MDBContainer } from "mdbreact";

export default class Footer extends Component {
  
  constructor(props) {
    super(props)
  }
  state = {
    collapseID: "",
    typestd: "",
    name: "",
  };

  toggleCollapse = collapseID => () =>
    this.setState(prevState => ({
      collapseID: prevState.collapseID !== collapseID ? collapseID : ""
    }));

  render() {
    return (<>
      <MDBContainer fluid>
        <MDBRow className="pt-3 pb-3" style={{ backgroundColor: "rgba(65, 65, 65, 0.8)" }}>
          <MDBCol className="text-left text-white" lg="12" md="12" sm="12">
            <h6 className="nospace">ติดต่อสอบถามเพิ่มเติมได้ที่</h6>
            ภาคปกติ - ภาคกศ.บป. &nbsp;<i className="fa fa-phone style4"></i>&nbsp;&nbsp;&nbsp;<a className="text-white style4" href="tel:055706547" target="_blank" >(055) 706 547</a> | <a className="text-white style4" href="https://www.facebook.com/kpru.register" target="_blank">Facebook</a><br />
            ปริญญาโท - ปริญญาเอก &nbsp;<i className="fa fa-phone style4"></i>&nbsp;&nbsp;&nbsp;<a className="text-white style4" href="tel:055706555" target="_blank">(055) 706 555 ต่อ 1780, 1671</a> | <a className="text-white style4" href="https://www.facebook.com/kprugrads/" target="_blank">Facebook</a><br />
            ประกาศนียบัตรบัณฑิต สาขาวิชาชีพครู &nbsp;<i className="fa fa-phone style4"></i>&nbsp;&nbsp;&nbsp;<a className="text-white style4" href="tel:055706555" target="_blank">(055) 706 555 ต่อ 2010</a> | <a className="text-white style4" href="https://www.facebook.com/edukpru/" target="_blank">Facebook</a>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
      <MDBRow className="pt-3 pb-3">
        <MDBCol className="text-left" lg="9" md="7" sm="6">
          <a href="https://www.kpru.ac.th" target="_blank">มหาวิทยาลัยราชภัฏกำแพงเพชร</a> 69 หมู่ 1 ต.นครชุม อ.เมือง จ.กำแพงเพชร 62000
        </MDBCol>
        <MDBCol className="text-left" lg="3" md="5" sm="6">
          Kamphaeng Phet Rajabhat University
        </MDBCol>
      </MDBRow>
    </>);
  }
}